import { EType } from '../../repositories/offer-card/entities/business_shopping_center/BusinessShoppingCenterSchema';

export function getFriendlyBCTCShortLabel(type: EType | null | undefined): string | null {
  switch (type) {
    case EType.BusinessCenter:
      return 'БЦ';
    case EType.ShoppingCenter:
      return 'ТЦ';
    case EType.Warehouse:
      return 'СК';
    default:
      return null;
  }
}
